import React, { useState } from "react";
import { ChipTagGroup } from "../../../../chip/presets/ChipTagGroup/ChipTagGroup";
import { ITagGroup } from "../../../../../models/tagGroups/TagGroupStore";
import { isEmpty } from "lodash";
import { AutoComplete } from "@fidget/common/components/form/autoComplete/autoComplete";
import { AgentButton } from "@fidget/common/components/inputs/buttons/agentButton/agentButton";
import { FullWidthBase } from "../../../../settings/settingsForms/base/fullWidthBase";
import { intl } from "@fidget/common/i18n";
import settingsStyles from "../../../../../styles/settings.css";
import styles from "./TargetTagGroupsColumn.css";
import classNames from "classnames";
import sharedStyles from "../../ManualAssignmentSettings.css";

interface Props {
  targetTagGroupIds: string[];
  allTagGroups: ITagGroup[];
  onDelete: (tagGroup: string) => void;
  onChange: (tagGroup: ITagGroup) => void;
  optionsItemProvider: () => ITagGroup[];
  tagGroupId: string;
  isEditing: boolean;
  hasError: boolean | undefined;
}

export const TargetTagGroupsColumn = ({
  allTagGroups,
  tagGroupId,
  targetTagGroupIds,
  onDelete,
  optionsItemProvider,
  onChange,
  isEditing,
  hasError
}: Props) => {
  const isTargetsEmpty = isEmpty(targetTagGroupIds);
  const [showingDropdown, setIsShowingDropdown] = useState<boolean>(false);

  const handleChange = (tagGroup: ITagGroup) => {
    setIsShowingDropdown(false);
    onChange(tagGroup);
  };

  const renderExistingTargetGroups = () => {
    return (
      !isTargetsEmpty && (
        <div className={styles["target-groups-container"]}>
          {targetTagGroupIds.map((target) => {
            const tagGroup = allTagGroups.find((item) => item.id === target);
            return (
              <ChipTagGroup
                key={target}
                name={tagGroup?.name || ""}
                enabled={!!tagGroup?.enabled}
                onDelete={isEditing ? () => onDelete(target) : undefined}
              />
            );
          })}
        </div>
      )
    );
  };

  const renderAddTransferTagButton = () => {
    return (
      <div className={isTargetsEmpty ? styles["no-margin"] : styles["add-button-targets-empty"]}>
        {showingDropdown || !tagGroupId || isTargetsEmpty ? (
          <div className={isTargetsEmpty ? styles["no-margin"] : styles["dropdown-targets-empty"]}>
            <AutoComplete<ITagGroup>
              onChange={handleChange}
              itemsProvider={optionsItemProvider}
              onStateChange={(_, stateAndHelpers) =>
                !stateAndHelpers.isOpen && !stateAndHelpers.selectedItem
                  ? setIsShowingDropdown(false)
                  : undefined
              }
              defaultIsOpen={showingDropdown && !isTargetsEmpty}
              itemToString={(val) => (val ? val.name : "")}
              placeholder={intl.formatMessage(
                "settings.assignmentRules.manualAssignment.form.tagGroup.placeholder"
              )}
              readOnly
              emptyPlaceholder={intl.formatMessage(
                "settings.assignmentRules.manualAssignment.form.tagGroup.placeholder"
              )}
              className={settingsStyles["input-width"]}
              onOutsideClick={() => setIsShowingDropdown(false)}
              hasError={hasError}
            />
          </div>
        ) : (
          <FullWidthBase containerClassName={styles["agent-button-container"]}>
            <AgentButton
              buttonStyle={"transparent primary"}
              onClick={() => setIsShowingDropdown(true)}
              textStyle={{ padding: 0 }}
            >
              {`+ ${intl.formatMessage(
                "settings.assignmentRules.manualAssignment.form.targetGroups.add"
              )}`}
            </AgentButton>
          </FullWidthBase>
        )}
      </div>
    );
  };

  return (
    <div className={styles.wrapper}>
      <p className={classNames(settingsStyles["form-label-font"], sharedStyles["label-margin"])}>
        {intl.formatMessage("settings.assignmentRules.manualAssignment.form.targetGroups.label")}
      </p>
      {renderExistingTargetGroups()}
      {isEditing && renderAddTransferTagButton()}
    </div>
  );
};
